/* ============================================================
   SPORTIVE HOMEPAGE - TABBED COLLECTIONS
   ============================================================ */

(function () {
  'use strict';

  function initTabs() {
    const tabSections = document.querySelectorAll('.sportive-tabs');

    tabSections.forEach(function (section) {
      const tabs = section.querySelectorAll('.sportive-tabs__tab');
      const panels = section.querySelectorAll('.sportive-tabs__panel');

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          if (panels[i]) panels[i].classList.add('is-active');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTabs);
})();
